import { render, staticRenderFns } from "./EmployeePageDetailModal.vue?vue&type=template&id=04c30438&scoped=true&"
import script from "./EmployeePageDetailModal.vue?vue&type=script&lang=js&"
export * from "./EmployeePageDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c30438",
  null
  
)

export default component.exports